import { Api } from "./Api";
import { Issue, CartItem, Order, Publication, CreatedOrder } from "./types";

export const OrderApi = {
  async createOrder(cartData: CartItem[], total: string) {
    try {
      const { data: response } = await Api.post<{ payload?: CreatedOrder }>(
        `/orders/create-order`,
        {
          cartData,
          total,
        }
      );
      return response.payload ?? null;
    } catch (error) {
      console.error(error);
    }
  },
  async getMyOrders() {
    try {
      const { data: response } = await Api.get<{ payload?: Order[] }>(
        "/orders/get-my"
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async getMyOrderedIssues() {
    try {
      const { data: response } = await Api.get<{ payload?: Issue[] }>(
        "/orders/get-my-ordered-issues"
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async getMyOrderedPublications() {
    try {
      const { data: response } = await Api.get<{ payload?: Publication[] }>(
        "/orders/get-my-ordered-publications"
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async getUserOrders(id: number) {
    try {
      const { data: response } = await Api.get<{ payload?: Order[] }>(
        `/orders/get-user-orders/${id}`
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async getOrderStatus(id: number) {
    try {
      const { data: response } = await Api.get(
        `/orders/get-order-status/${id}`
      );
      return response.payload ?? null;
    } catch (error) {
      console.error(error);
    }
  },
  async getOrderData(id: number) {
    try {
      const { data: response } = await Api.get<{ payload?: Order }>(
        `/orders/get-order/${id}`
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async sendReceipt(email: string, orderId: number, pdfBase64: string) {
    try {
      await Api.post("/orders/send-receipt", {
        email,
        orderId,
        pdfBase64,
      });
    } catch (error) {
      console.error("Failed to send receipt:", error);
    }
  },
};
